import React from 'react';
import { ArrowLeft, Calendar, DollarSign, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { PeopleTravelTrip } from '../../../types';
import './PeopleTravel.css';

type Props = {
  trip: PeopleTravelTrip;
  travelerLabels: string[];
  onOpenBudget?: () => void;
  onOpenCalendar?: () => void;
};

const statusClass = (status: PeopleTravelTrip['status']) =>
  `people-travel-status people-travel-status--${status}`;

const PeopleTravelTripHeader: React.FC<Props> = ({
  trip,
  travelerLabels,
  onOpenBudget,
  onOpenCalendar,
}) => {
  const navigate = useNavigate();

  return (
    <div className="people-travel-header">
      <div>
        <button
          type="button"
          className="pm-btn pm-btn-ghost people-hub-back-link"
          onClick={() => navigate('/people/travel')}
        >
          <ArrowLeft size={14} /> All trips
        </button>
        <h2 className="ops-hub-title" style={{ marginTop: 6 }}>
          {trip.title}
        </h2>
        <div className="people-travel-header-meta">
          <span className={statusClass(trip.status)}>{trip.status}</span>
          <span className="people-travel-chip">
            <Calendar size={12} />
            {trip.startDate && trip.endDate ? `${trip.startDate} → ${trip.endDate}` : 'Dates TBD'}
          </span>
          <span className="people-travel-chip">
            <Users size={12} />
            {travelerLabels.join(', ') || 'No travelers'}
          </span>
          <button
            type="button"
            className="people-travel-chip people-travel-chip-btn"
            onClick={onOpenBudget}
            disabled={!onOpenBudget}
          >
            <DollarSign size={12} />
            ${trip.budget.selectedTotal.toLocaleString()} selected
            {trip.budget.cap ? ` / $${trip.budget.cap.toLocaleString()} cap` : ''}
          </button>
          {onOpenCalendar && (
            <button type="button" className="people-travel-chip people-travel-chip-btn" onClick={onOpenCalendar}>
              <Calendar size={12} />
              Calendar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PeopleTravelTripHeader;
